// router module import
import main from '@router/module/common/main';
import auth from '@router/module/common/auth';
import generativeBbs from '@router/module/common/generativeBbs';
import sample from '@router/module/common/sample';

const routes = [...main, ...auth, ...generativeBbs, ...sample];

export default routes;
